module.exports = __webpack_public_path__ + "d0d4e5a215813c421b7913b5459c66da.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hair-granny-s.png
// module id = 2688
// module chunks = 0